import { jsx as themeUIJsx, jsxs as themeUIJsxs } from "@theme-ui/core/jsx-runtime"; // eslint-disable-next-line no-restricted-imports

import { createElement as themeUICreateElement } from "@theme-ui/core";
import { parseProps } from "./stylingLibJsx";
import { ValidationCollector } from "./NessieValidationErrorPanel";
import { isDev } from "@classdojo/web/utils/env";
// https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md
//
// React now has two different JSX runtime modes:
//   - classic
//   - automatic
//
// They specify different function interfaces with different parameters being passed.
// This needs to match the way that we configure Babel on which JSX transform to use,
// so keep that in mind if doing any changes to configuration or this function.
//
// This implementation handles the "automatic" mode
export { Fragment } from "@theme-ui/core/jsx-runtime";
// this handles JSX elements where children is a single node
export var jsx = function jsx(type, props, key) {
  if (!(props !== null && props !== void 0 && props.sx)) {
    return themeUIJsx(type, props, key);
  }
  var validationContext = {
    location: typeof type === "string" ? type : type === null || type === void 0 ? void 0 : type.name,
    errors: []
  };
  parseProps(props, validationContext); // Only run the 'nessie validation panel UI' if we are in Dev

  if (isDev) {
    props.__stylingLibInternal_type = type;
    props.__stylingLibInternal_validationContext = validationContext;
    return themeUIJsx(ValidationCollector, props, key);
  }
  return themeUIJsx(type, props, key);
}; // this handles JSX elements where children is an array

export var jsxs = function jsxs(type, props, key) {
  if (!(props !== null && props !== void 0 && props.sx)) {
    return themeUIJsxs(type, props, key);
  }
  var validationContext = {
    location: typeof type === "string" ? type : type === null || type === void 0 ? void 0 : type.name,
    errors: []
  };
  parseProps(props, validationContext); // Only run the 'nessie validation panel UI' if we are in Dev

  if (isDev) {
    props.__stylingLibInternal_type = type;
    props.__stylingLibInternal_validationContext = validationContext;
    return themeUIJsxs(ValidationCollector, props, key);
  }
  return themeUIJsxs(type, props, key);
}; // this is a fallback to the "classic" style of JSX transform

export var createElement = function createElement(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }
  if (!(props !== null && props !== void 0 && props.sx)) {
    return themeUICreateElement.apply(void 0, [type, props].concat(children));
  }
  var validationContext = {
    location: typeof type === "string" ? type : type === null || type === void 0 ? void 0 : type.name,
    errors: []
  };
  parseProps(props, validationContext); // Only run the 'nessie validation panel UI' if we are in Dev

  if (isDev) {
    props.__stylingLibInternal_type = type;
    props.__stylingLibInternal_validationContext = validationContext;
    return themeUICreateElement.apply(void 0, [ValidationCollector, props].concat(children));
  }
  return themeUICreateElement.apply(void 0, [type, props].concat(children));
};